import React from "react";
import Logo from "assets/images/logo-light.png";
import { NavLink } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
// import { NavLink } from "react-router-dom";
const Header = () => {
  return (
    <header style={{ background: "rgba(4,8,40,0.95)" }}>
      <Navbar expand="lg">
        <Navbar.Brand as={NavLink} to="/">
          <img src={Logo} className="h-[50px]" alt="not-found" />
        </Navbar.Brand>
        <Navbar.Toggle className="bg-white" aria-controls="headerNav" />
        <Navbar.Collapse id="headerNav">
          <Nav as="ul" className="ml-auto">
            <li className="nav-item">
              <NavLink className="nav-link" to="/" end>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/services">
                Services{" "}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about">
                About us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/portfolio">
                Portfolio
              </NavLink>
            </li>
            <a href="#contact" className="btn btn-outline-blue-white my-2 my-sm-0 mr-5" type="submit">
              GET A QUOTE
            </a>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
